// extracted by mini-css-extract-plugin
module.exports = {"costco":"styles_costco__311N9","img":"styles_img__1V0D_","costcoInfo":"styles_costcoInfo__J-mna"};